import { SettingsSection } from './SettingsSection';
import { PasswordResetSection } from './PasswordResetSection';
import MFAManagement from '../MFAManagement';
import { DeviceTrust } from '../DeviceTrust';

export const SecurityContent = () => {
  return (
    <>
      <SettingsSection
        id="settings-password"
        title="Password"
        subtitle="Change your account password"
      >
        <PasswordResetSection />
      </SettingsSection>

      <SettingsSection
        id="settings-mfa"
        title="Multi-Factor Authentication"
        subtitle="Add an extra layer of security to your account"
      >
        <MFAManagement />
      </SettingsSection>

      <SettingsSection
        id="settings-devices"
        title="Trusted Devices"
        subtitle="Manage devices that can skip MFA verification"
      >
        <DeviceTrust />
      </SettingsSection>
    </>
  );
};
